export default "__VITE_PUBLIC_ASSET__75f6961f__"